import React from 'react';
export class ToggleLoading extends React.Component {
   render() {
      return <div className='neo-icon-spinner toggle-loading spinning'></div>;
   }
};
